export default __webpack_public_path__ + "static/media/chillrxgraph-mobile.png.webp";